import { render, staticRenderFns } from "./AppDashboard.vue?vue&type=template&id=4d30b6ba&"
import script from "./AppDashboard.vue?vue&type=script&lang=js&"
export * from "./AppDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports